/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ContentSearchRequestModel {
    /** @format int32 */
    searchType: number;
    /** @format int32 */
    page: number;
    /** @format int32 */
    resultsPerPage: number;
    facetFilters: SearchRequestFacetFilterModel[];
    searchTerm: string;
    searchLanguage: string;
    logActivity: boolean;
}

export interface ContentSearchResponseModel {
    results: ContentSearchResultModel[];
    facetFilters: FacetFilterModel[];
    /** @format int32 */
    count: number;
    hasNdaAccess: boolean;
}

export interface ContentSearchResultModel {
    contentTypeName: string;
    documentUrl: string;
    documentTitle: string;
    documentDescription?: string | null;
    documentImageUrl: string;
    documentCategory: string;
    documentVersion?: string | null;
    documentReleaseDate?: string | null;
    documentFileType?: string | null;
    documentLanguage?: string | null;
    documentAccessibility?: string | null;
    documentFileSize?: string | null;
}

export interface DeleteFilesResponseModel {
    /** @format int32 */
    uniqueId: number;
    /** @format int32 */
    status: number;
    message?: string | null;
}

export interface DocumentSearchRequestModel {
    searchType: DocumentSearchType;
    /** @format int32 */
    page: number;
    /** @format int32 */
    resultsPerPage: number;
    facetFilters: SearchRequestFacetFilterModel[];
    searchTerm: string;
    searchLanguage: string;
    sortBy: string;
    onlyBookmarked: boolean;
    logActivity: boolean;
}

export interface DocumentSearchResponseModel {
    results: DocumentSearchResultModel[];
    facetFilters: FacetFilterModel[];
    /** @format int32 */
    count: number;
    supportBookmarks: boolean;
    hasNdaAccess: boolean;
}

export interface DocumentSearchEulaModel {
    intro?: string | null;
    body: string;
    contact: string;
}

export interface DocumentSearchResultModel {
    contentTypeName: string;
    /** @format int32 */
    contentItemId: number;
    /** @format int32 */
    bookmarkId?: number | null;
    designResourceType?: string | null;
    documentName: string;
    documentDescription?: string | null;
    documentVersion?: string | null;
    documentReleaseDate?: string | null;
    documentFileType: string;
    documentFileTypeRom?: string | null;
    documentLanguage?: string | null;
    documentAccessibility?: string | null;
    documentFileSize: string;
    documentFileSizeRom?: string | null;
    downloadUrl: string;
    documentVendor?: string | null;
    documentPlatforms?: string[] | null;
    documentCategories?: string[] | null;
    documentUrl?: string | null;
    imageUrl?: string | null;
    logoUrl?: string | null;
    eula?: DocumentSearchEulaModel | null;
}

/** @format int32 */
export enum DocumentSearchType {
    Documents = 0,
    DesignResources = 1,
    Tools = 2,
    Ppl = 3,
    PartnerBoards = 4,
    CompanionModules = 5,
    PlatformDocuments = 6,
    App = 7
}

export interface FacetFilterModel {
    name: string;
    displayName: string;
    values: FacetFilterValueModel[];
}

export interface FacetFilterValueModel {
    value: string;
    displayName: string;
    /** @format int64 */
    count: number;
    checked: boolean;
    /** @format int32 */
    level: number;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    /** @format int32 */
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    [key: string]: any;
}

export interface ReleaseFilesRequestModel {
    onlyUpdateProperty: boolean;
    /** @format int32 */
    uniqueId: number;
    fileEntityPath: string;
    dmsPath: string;
    dmsLink: string;
    version: string;
    releasedTime: string;
    language: string;
    accessibility: string;
    displayName: string;
    documentCategories: string[];
    platforms: string[];
    documentTypes: string[];
    technicalDomains: string[];
}

export interface ReleaseFilesResponseModel {
    /** @format int32 */
    contentItemId: number;
    documentName: string;
    /** @format int32 */
    uniqueId: number;
    /** @format int32 */
    status: number;
    message: string;
    cmsLink?: string | null;
}

export interface SearchRequestFacetFilterModel {
    name: string;
    values: string[];
    min?: string | null;
    max?: string | null;
}
